<template>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
      <tr>
        <th v-for="(column, index) in columns" :key="index">
          {{ column.label }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in items" :key="index">
        <td v-for="(column, index) in columns" :key="index">
          <template v-if="$scopedSlots[column.key]">
            <slot :name="column.key" :item="item" :value="item[column.key]" :index="index"/>
          </template>
          <span v-else>{{ item[column.key] }}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'OrderTypeTable',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    }
  },
}
</script>
